<script>
    export let size = "100px";
</script>

<style>
    div {
        animation: rotation 500ms ease-in-out 0ms infinite;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>

<div
    class="border-b-4 border-r-4 border-l-4 border-blue-500 rounded-full"
    style={`height: ${size}; width: ${size};`} />
